import * as React from "react";
import { cn } from "../../utils";

interface MiniBarRowProps {
  /** Left label. */
  label: React.ReactNode;
  /** Right value displayed after the bar. */
  value: React.ReactNode;
  /** Bar fill width as a percentage, 0-100. */
  width: number;
  /** CSS color for the bar fill. */
  color: string;
  /** Tailwind width class for the label column (e.g. "w-16"). */
  labelWidth?: string;
  /** Tailwind width class for the value column (e.g. "w-7"). */
  valueWidth?: string;
  className?: string;
}

/**
 * Single horizontal "label + thin progress bar + value" row. Used in
 * `SessionSidebar` (token breakdown), `McpServerPanel` (per-server tool bars),
 * and `lens/projects/project-card` (top-tools bar chart). Three near-identical
 * inline reimplementations consolidated into one block.
 */
export function MiniBarRow({
  label,
  value,
  width,
  color,
  labelWidth = "w-16",
  valueWidth = "w-7",
  className,
}: MiniBarRowProps) {
  return (
    <div className={cn("flex items-center gap-2 type-body", className)}>
      <span className={cn("text-muted-foreground truncate", labelWidth)}>
        {label}
      </span>
      <div className="flex-1 h-1.5 bg-muted rounded-lg overflow-hidden">
        <div
          className="h-full rounded-lg transition-all"
          style={{
            width: `${Math.max(2, Math.min(100, width))}%`,
            backgroundColor: color,
          }}
        />
      </div>
      <span
        className={cn(
          "text-foreground text-right tabular-nums",
          valueWidth,
        )}
      >
        {value}
      </span>
    </div>
  );
}
